import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/Select';
import { Flex } from 'components/layout';
import { Typography } from 'components/typography';

import {
  THREEG_DOCUMENT_MESSAGE_TYPE_OPTIONS,
  ThreeGDocumentMessageType,
} from './constants';

type ThreeGDocumentTypeSelectProps = {
  value: ThreeGDocumentMessageType;
  onChange: (value: ThreeGDocumentMessageType) => void;
  disabled?: boolean;
};

export function ThreeGDocumentTypeSelect({
  value,
  onChange,
  disabled,
}: ThreeGDocumentTypeSelectProps) {
  return (
    <Flex direction='col' gap='xs'>
      <Typography variant='body-xs' className='text-neutral-600'>
        Document Type
      </Typography>
      <Select
        value={value}
        disabled={disabled}
        onValueChange={(next) => onChange(next as ThreeGDocumentMessageType)}
      >
        <SelectTrigger className='w-full' aria-label='Document Type'>
          <SelectValue placeholder='Select document type' />
        </SelectTrigger>
        <SelectContent>
          {THREEG_DOCUMENT_MESSAGE_TYPE_OPTIONS.map((type) => (
            <SelectItem key={type.value} value={type.value}>
              {type.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Flex>
  );
}
